module.exports = __webpack_public_path__ + "img/header.92fd77c.png";